module.exports = __webpack_public_path__ + "images/icons_v2/quantity-chevrons-1a525c24.svg";